module.exports = __webpack_public_path__ + "static/media/8.e1d86023.jpg";